import React from 'react';

/**
 * TechMarquee — infinite horizontal scroll showing tools / domains as a
 * "trust band". Pauses on hover. Respects prefers-reduced-motion via the
 * global CSS rule in index.css (reduces animation-duration to 0.001ms).
 */
const TOKENS = [
  'AZURE', 'AWS', 'PYTHON', 'TENSORFLOW', 'POWER BI', 'SOLIDWORKS',
  'FUSION 360', 'IoT EDGE', 'KUBERNETES', 'TERRAFORM', 'OPENAI', 'ARDUINO',
  'GRAFANA', 'POSTGRESQL', 'REACT', 'NEXT.JS', 'FASTAPI', 'DOCKER',
];

const Pill = ({ children, accent }) => (
  <div className="flex items-center gap-3 shrink-0 px-5">
    <span
      className="w-1 h-1 rounded-full"
      style={{
        background: accent ? 'var(--warning-amber)' : 'var(--hyper-cyan)',
        boxShadow: accent
          ? '0 0 6px var(--warning-amber)'
          : '0 0 6px var(--hyper-cyan)',
      }}
    />
    <span className="font-mono text-[10px] sm:text-[11px] tracking-[0.32em] uppercase text-white/55 whitespace-nowrap">
      {children}
    </span>
  </div>
);

export default function TechMarquee() {
  // Duplicate the token list so the track loops seamlessly without a visible jump
  const list = [...TOKENS, ...TOKENS];
  return (
    <section
      className="relative border-y border-white/8 bg-black/30 backdrop-blur-[2px] overflow-hidden py-4 sm:py-5"
      data-testid="tech-marquee"
      aria-label="Tools and platforms"
    >
      {/* Left/right fade masks so tokens dissolve into the page edges */}
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 sm:w-40 bg-gradient-to-r from-[#0E1116] to-transparent z-10" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 sm:w-40 bg-gradient-to-l from-[#0E1116] to-transparent z-10" />

      <div className="flex marquee-track" style={{ width: 'max-content' }}>
        {list.map((t, i) => (
          <Pill key={`${t}-${i}`} accent={i % 7 === 0}>
            {t}
          </Pill>
        ))}
      </div>
    </section>
  );
}
